export default () => {
    let systemInfo = window.sessionStorage.getItem('systemInfo');
    systemInfo = (systemInfo && JSON.parse(systemInfo)) || {};

    let val = {
        ...systemInfo,
        longitude: systemInfo.longitude,
        latitude: systemInfo.latitude,
        mapType: 'wgs84',
    };
    if (systemInfo?.mapDefJson) {
        let mapDefJson = JSON.parse(systemInfo.mapDefJson) || [];
        let defaultMap = mapDefJson.find(v => v.defaultMap) || {};
        val = {
            ...val,
            ...defaultMap,
            mapType: defaultMap.coordinate || 'wgs84',
        };
    }

    return val;
};
